import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

var styles = function styles(theme) {
  return {
    'kailona-button': {
      height: '40px',
      borderRadius: '4px',
      color: theme.palette.primary.main,
      backgroundColor: '#fff !important',
      border: '1px solid #9FA8DA !important',
      textAlign: 'center',
      fontFamily: 'Nunito Sans',
      fontStyle: 'normal',
      fontWeight: '800',
      fontSize: '15px',
      letterSpacing: '0.25px',
      textTransform: 'none',
      '&.disabled, &:disabled': {
        backgroundColor: '#fff !important',
        borderColor: "".concat(theme.palette.gray30.main, " !important"),
        color: "".concat(theme.palette.gray30.main, " !important"),
        pointerEvents: 'none'
      },
      '&.default': {
        color: theme.palette.gray60.main,
        backgroundColor: '#fff !important',
        border: "1px solid ".concat(theme.palette.gray60.main, " !important"),
        '&:hover': {
          backgroundColor: "".concat(theme.palette.whiteSmoke.main, " !important")
        }
      },
      '&.primary': {
        color: theme.palette.primary.main,
        backgroundColor: '#fff !important',
        border: '1px solid #9FA8DA !important',
        '&:hover': {
          backgroundColor: '#E5E9FF !important',
          color: "".concat(theme.palette.primary.main, " !important"),
          borderColor: '#9FA8DA !important'
        },
        '&:active': {
          backgroundColor: "theme.palette.primary.light !important",
          color: "".concat(theme.palette.primary.main, " !important"),
          border: "1px solid ".concat(theme.palette.primary.main)
        }
      },
      '&.error': {
        backgroundColor: theme.palette.error.main,
        color: "".concat(theme.palette.white.main, " !important"),
        border: "1px solid ".concat(theme.palette.error.main),
        '&:hover': {
          backgroundColor: "".concat(theme.palette.error.dark, " !important"),
          color: "".concat(theme.palette.white.main, " !important"),
          borderColor: "".concat(theme.palette.error.dark, " !important")
        }
      }
    }
  };
};

var KailonaButton = /*#__PURE__*/function (_Component) {
  _inherits(KailonaButton, _Component);

  var _super = _createSuper(KailonaButton);

  function KailonaButton() {
    _classCallCheck(this, KailonaButton);

    return _super.apply(this, arguments);
  }

  _createClass(KailonaButton, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return /*#__PURE__*/React.createElement(Button, {
        className: "".concat(classes['kailona-button'], " ").concat(this.props.class),
        variant: this.props.variant,
        color: this.props.color,
        style: this.props.style,
        onClick: this.props.onClick,
        disableRipple: true,
        disabled: this.props.disabled
      }, this.props.title, this.props.loading && /*#__PURE__*/React.createElement(CircularProgress, {
        color: "primary",
        size: 20,
        style: {
          marginLeft: '12px'
        }
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return KailonaButton;
}(Component);

var _default = withStyles(styles)(KailonaButton);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/Buttons/KailonaButton.js");
  reactHotLoader.register(KailonaButton, "KailonaButton", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/Buttons/KailonaButton.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/Buttons/KailonaButton.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();